
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/di-che-ramo-sei/educational-vita/[slug]",
      function () {
        return require("private-next-pages/di-che-ramo-sei/educational-vita/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/di-che-ramo-sei/educational-vita/[slug]"])
      });
    }
  